module.exports = __webpack_public_path__ + "static/multi-level-joint-3ebf46010ad0faf0d38a7ae0aff7f5ba.jpeg";